import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Gate from "./pages/Gate";
import Funnel from "./pages/Funnel";
import Assessment from "./pages/Assessment";
import AdminLeads from "./pages/AdminLeads";
import { MO_TOKEN_KEY } from "./lib/api";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="evc-app" data-testid="evc-app">
      <Toaster richColors position="top-center" />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Gate />} />
          <Route path="/start" element={<Funnel />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/leads" element={<AdminLeads />} />
          <Route
            path="/MO"
            element={
              <AdminLeads
                tokenKey={MO_TOKEN_KEY}
                title="magicorange · Leads"
                subtitle="Pre-sales dashboard - leads generated through the magicorange access code."
                kicker="magicorange · Partner"
              />
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
